import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import SingleBlog from '../../components/Blog';

import blogImg1 from '../../assets/img/blog/blog-1-1.jpg';
import blogImg2 from '../../assets/img/blog/blog-1-2.jpg';
import blogImg3 from '../../assets/img/blog/blog-1-3.jpg';
import blogImg4 from '../../assets/img/blog/blog-1-4.jpg';
import blogImg5 from '../../assets/img/blog/blog-1-5.jpg';
import blogImg6 from '../../assets/img/blog/blog-1-6.jpg';
import blogImg7 from '../../assets/img/blog/blog-1-7.jpg';
import blogImg8 from '../../assets/img/blog/blog-1-8.jpg';
import blogImg9 from '../../assets/img/blog/blog-1-9.jpg';

const BlogMain = () => {
  return (
    <main>
      <Breadcrumb title="Blog" />

      <div className="it-blog-area fix pt-120 pb-90">
        <div className="container">
          <div className="row">
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <SingleBlog
                blogImage={blogImg1}
                publishedDate="10"
                publishedMonth="March 24"
                authorName="Camsth Smith"
                title="Healthcare Tips Navigating Business Patient Care"
                btnText="Read More"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <SingleBlog
                blogImage={blogImg3}
                publishedDate="05"
                publishedMonth="June 24"
                authorName="Camsth Smith"
                title="Healthcare Tips Navigating Business Patient Care"
                btnText="Read More"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <SingleBlog
                blogImage={blogImg2}
                publishedDate="21"
                publishedMonth="May 24"
                authorName="Camsth Smith"
                title="Healthcare Tips Navigating Business Patient Care"
                btnText="Read More"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <SingleBlog
                blogImage={blogImg4}
                publishedDate="11"
                publishedMonth="April 24"
                authorName="Camsth Smith"
                title="Healthcare Tips Navigating Business Patient Care"
                btnText="Read More"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <SingleBlog
                blogImage={blogImg5}
                publishedDate="20"
                publishedMonth="July 24"
                authorName="Camsth Smith"
                title="Healthcare Tips Navigating Business Patient Care"
                btnText="Read More"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <SingleBlog
                blogImage={blogImg6}
                publishedDate="09"
                publishedMonth="May 24"
                authorName="Camsth Smith"
                title="Healthcare Tips Navigating Business Patient Care"
                btnText="Read More"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <SingleBlog
                blogImage={blogImg7}
                publishedDate="19"
                publishedMonth="July 24"
                authorName="Camsth Smith"
                title="Healthcare Tips Navigating Business Patient Care"
                btnText="Read More"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <SingleBlog
                blogImage={blogImg8}
                publishedDate="28"
                publishedMonth="March 24"
                authorName="Camsth Smith"
                title="Healthcare Tips Navigating Business Patient Care"
                btnText="Read More"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <SingleBlog
                blogImage={blogImg9}
                publishedDate="15"
                publishedMonth="April 24"
                authorName="Camsth Smith"
                title="Healthcare Tips Navigating Business Patient Care"
                btnText="Read More"
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default BlogMain;
